import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-6" data-testid="notfound-page">
      <p className="font-serif text-8xl md:text-9xl font-light text-gold leading-none">404</p>
      <h1 className="font-serif text-3xl md:text-4xl font-light mt-4 mb-3">Questo incanto non esiste</h1>
      <p className="text-muted-foreground max-w-md mb-8">La pagina che cerchi non è tra le nostre creazioni. Torna al giardino.</p>
      <Link to="/">
        <Button className="rounded-full bg-gold hover:bg-gold/90 text-white h-12 px-8" data-testid="notfound-home-btn">Torna alla home</Button>
      </Link>
    </div>
  );
}
